.bam-compliance {
    font-family: var(--font-family);
}

.dark-mode figure {
    background-color: var(--color-dark-quaternary);
    padding: var(--spacing-tiny);
    border-radius: var(--border-small);
}